import axios from 'axios'
import { unsafeGetToken } from '../ducks/auth'

const getToken = app => {
  return unsafeGetToken(null, app)
}

export const getUserValue = async (app, baseURL, library, key) => {
  try {
    let token = getToken(app)

    if (!token) {
      return null
    }

    let result = await axios.get(`${baseURL}/values`, {
      headers: { Authorization: `Bearer ${token}` },
    })

    let { data } = result

    return data[library] && data[library][key]
  } catch (err) {
    return null
  }
}

export const setUserValue = async (app, baseURL, library, key, value) => {
  let url = `${baseURL}/values/${library}/${key}`
  let payload = { value }
  let token = getToken(app)

  if (!token) {
    return { [library]: {} }
  }

  let result = await axios.put(url, payload, {
    headers: { Authorization: `Bearer ${token}` },
  })

  return result.data
}
